import React from 'react';
import {FormControlLabel, Radio} from '@mui/material';
import {
	LegacyFormRadiosField,
	type InputForm,
} from '@netx/core-components/Form';
import type {ICustomFormItem} from '../../types';
import {
	getCustomFormItemTranslatedLabel,
	getCustomFormBaseFieldName,
} from '../../utils';

export interface LegacyFormCustomFormItemRadiosProps {
	item: ICustomFormItem<'radios'>;
	form: InputForm;
	value?: string;
}

export const LegacyFormCustomFormItemRadiosPrimitive = ({
	item,
	form,
	value: _value,
}: LegacyFormCustomFormItemRadiosProps) => {
	const {label, value, required, userValue, disabled} = item;

	if (typeof value === 'string') return null;

	return (
		<LegacyFormRadiosField
			disabled={disabled}
			form={form}
			label={getCustomFormItemTranslatedLabel(label)}
			name={getCustomFormBaseFieldName(item)}
			required={required}
			value={_value != null ? _value : userValue.toString()}
		>
			{value.map((val) => (
				<FormControlLabel
					value={typeof val === 'string' ? val : val.key}
					disabled={disabled || typeof val === 'string' ? false : val.disabled}
					control={<Radio />}
					label={
						<span
							dangerouslySetInnerHTML={{
								__html:
									typeof val === 'string'
										? val
										: getCustomFormItemTranslatedLabel(val),
							}}
						/>
					}
				/>
			))}
		</LegacyFormRadiosField>
	);
};

export const LegacyFormCustomFormItemRadios =
	LegacyFormCustomFormItemRadiosPrimitive;

export default LegacyFormCustomFormItemRadios;
